import * as React from 'react';
import { Grid, Card, CardContent, Container } from '@mui/material';
import Moment from 'react-moment';
import moment from 'moment';
import PolicyClausesPreview from './PolicyClausesPreview';
import PolicyDatasPreview from './PolicyDatasPreview';

export default function PdfRfqPreview() {
  const [pdfPreview, setPdfPreviewDatas] = React.useState(null);

  React.useEffect(() => {
    const urlEncoded = window.location.pathname.split('/')[2];
    let bufferObj = Buffer.from(urlEncoded, 'base64');
    let decodedString = bufferObj.toString('utf8');
    getRfqDatasById(JSON.parse(decodedString));
  }, []);

  const getRfqDatasById = (bodyDatas) => {
    console.log(bodyDatas);
    const URL =
      bodyDatas?.type === 'Claim'
        ? 'claimRequest/getClaimRequestDetails'
        : 'requestForQuotation/getRfqDetailsById';
    fetch(process.env.REACT_APP_API_URL + URL, {
      method: 'post',
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + bodyDatas.authToken
      },
      body: JSON.stringify({
        rfqId: bodyDatas.rfqId, //For RFQ
        id: bodyDatas.claimId, //For Claim
        companyId: bodyDatas.companyId
      })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setPdfPreviewDatas(data['data']);
        }
      })
      .catch(function (err) {
        console.log('Data', 'Error : ' + err.message, 'error');
      });
  };
  const generatePolicyType = (requirement) => {
    let policy = '';
    if (requirement.action === 'NewPolicy') {
      policy = 'New';
    } else if (requirement.action === 'PolicyEndorsement') {
      policy = 'Endorsement';
    } else if (requirement.action === 'PolicyRenewal') {
      policy = 'Renewal';
    } else {
      policy = 'Claim';
    }
    return policy;
  };

  return (
    <>
      <Container maxWidth="xl">
        <Grid container md={12} spacing={2} mb={1} mt={1}>
          <Grid item md={12}>
            <Card
              sx={{
                border: '1px dashed grey',
                width: '765px'
              }}
            >
              <CardContent>
                {pdfPreview?.requirement?.action !== 'PolicyClaim' ? (
                  <>RFQ No : RFQ#{pdfPreview?.id}</>
                ) : (
                  <>Claim Req No : {pdfPreview?.title}</>
                )}
                <br />
                RQ No : {pdfPreview?.requirement?.uniquecode} <br />
                {pdfPreview?.requirement?.action === 'PolicyClaim' ? (
                  <>
                    Claim Amount : ₹{pdfPreview?.claimAmount} <br />
                    Incident Date Time :{' '}
                    <Moment format="MMM  DD, YYYY">
                      {pdfPreview?.incidentDate}
                    </Moment>{' '}
                    {moment(pdfPreview?.incidentTime, ['HH:mm']).format(
                      'hh:mm a'
                    )}
                    <br />
                  </>
                ) : null}
                {pdfPreview?.requirement ? (
                  <>
                    Policy : &nbsp;
                    {generatePolicyType(pdfPreview?.requirement) +
                      ' ' +
                      pdfPreview?.requirement?.category?.name}
                  </>
                ) : null}
                <br />
                Customer Name : {pdfPreview?.customer?.name} <br />
                Customer Phone : {pdfPreview?.customer?.phone} <br />
                Created Date:{' '}
                <Moment format="MMM  DD, YYYY  h:mm a">
                  {pdfPreview?.createdAt}
                </Moment>
                <br />
              </CardContent>
            </Card>
            {/* Printing Policy Clauses */}
            {pdfPreview?.requirement?.action !== 'PolicyClaim' ? (
              <PolicyClausesPreview pdfPreview={pdfPreview} />
            ) : null}
            {/* #End of policy Clauses */}
          </Grid>
        </Grid>
        {
          pdfPreview?.requirement?.action === 'PolicyClaim'
            ? //Printing policy claim datas
              pdfPreview?.claimData?.map((previewData) => {
                return <PolicyDatasPreview previewData={previewData} />;
              })
            : //#End
              //Printing other action datas
              pdfPreview?.rfqData?.map((previewData) => {
                return <PolicyDatasPreview previewData={previewData} />;
              })
          //#End
        }
      </Container>
      <br />
      <br />
    </>
  );
}
